const EventsPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">Upcoming Events</h2>
    <div className="space-y-6">
      <div className="bg-green-50 p-6 rounded-lg shadow-md border border-green-200">
        <h3 className="text-2xl font-semibold text-green-700 mb-2">
          Yoga & Meditation Retreat
        </h3>
        <p className="text-gray-700 mb-2">
          <strong>Date:</strong> October 20-22, 2025
        </p>
        <p className="text-gray-700 mb-2">
          <strong>Location:</strong> Serene Valley Retreat Center
        </p>
        <p className="text-gray-600">
          Join us for a rejuvenating weekend of deep yoga practice, guided
          meditation, and healthy cuisine amidst nature.
        </p>
      </div>
      <div className="bg-blue-50 p-6 rounded-lg shadow-md border border-blue-200">
        <h3 className="text-2xl font-semibold text-blue-700 mb-2">
          Beginner's Workshop: Foundations of Yoga
        </h3>
        <p className="text-gray-700 mb-2">
          <strong>Date:</strong> September 15, 2025
        </p>
        <p className="text-gray-700 mb-2">
          <strong>Time:</strong> 10:00 AM - 1:00 PM
        </p>
        <p className="text-gray-600">
          Perfect for newcomers! Learn fundamental poses, breathing techniques,
          and yoga philosophy in this intensive workshop.
        </p>
      </div>
      <div className="bg-yellow-50 p-6 rounded-lg shadow-md border border-yellow-200">
        <h3 className="text-2xl font-semibold text-yellow-700 mb-2">
          Community Yoga Day
        </h3>
        <p className="text-gray-700 mb-2">
          <strong>Date:</strong> August 5, 2025
        </p>
        <p className="text-gray-700 mb-2">
          <strong>Time:</strong> 9:00 AM - 11:00 AM
        </p>
        <p className="text-gray-600">
          Free outdoor yoga session for all levels. Bring your mat and a friend!
        </p>
      </div>
    </div>
  </div>
);

export default EventsPage;
